export default {
  isAuthenticated: state => !!state.token && (state.status !== 'error'),
  isError: state => (state.status === 'error'),
  parish: state => state.parish
}
